import React from "react"
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Box,
} from "@mui/material"
import moment from "moment"
import { getColor, getFullName, getTime } from "../../utils/Helpers"
import {
  ApiMethods,
  BREAK,
  CANCEL,
  CANCELLED,
  COMPLETED,
  MEETING,
  sideBarStatusOptions,
  statusCodes,
  SURGERY,
  ON_GOING,
} from "../../utils/constants"
import CustomMenu from "../GlobalComponents/CustomMenu"
import { ApiRequest } from "../../services/api-request"
import { ApiPaths } from "../../utils/apiConstants"

export function EventCards(props) {
  const { events, getScheduleData = () => { }, selectedOption, onSelectEventCard } = props

  function onChangeOption(event, status) {
    if (event?.status === status || status === "backdropClick") return null
    if (status === CANCEL) {
      status = CANCELLED
    }

    const { _id = "" } = event
    ApiRequest({
      url: ApiPaths.UPDATE_EVENT_STATUS,
      method: ApiMethods.PUT,
      data: { id: _id, status },
    })
      .then((response) => {
        const { data = {} } = response
        if (data?.status === statusCodes.success) {
          getScheduleData()
        }
      })
      .catch((error) => console.error(error))
  }

  console.log("evvvvvvents", events, selectedOption)

  return (
    <div>
      {events.length > 0 ? (
        <div
          spacing={1}
          style={{ gap: "10px", display: "flex", flexDirection: "column" }}
        >
          {events.map((event) => {
            if (selectedOption !== "All" && selectedOption !== event.status) {
              return <></>
            }
            let backgroundColor = getColor(event.status)
            let isCompleted = event.status === COMPLETED
            const doctorName = event.doctorFirstName + (event?.doctorLastName ? ` ${event?.doctorLastName}` : "")
            const isMeeting = event.appointmentType === MEETING
            const isBreak = event.appointmentType === BREAK
            const isSurgery = event.appointmentType === SURGERY
            let creatorName = event?.creatorId ? getFullName({
              firstName: event?.creatorFirstName,
              lastName: event?.creatorLastName,
            }) : ""
            let isCancelled = event?.status === CANCELLED
            function isFutureEvent(event) {
              const currentDate = new Date()
              currentDate.setDate(currentDate.getDate() + 1)
              currentDate.setHours(0, 0, 0, 0)

              const eventDate = new Date(event.start)
              return eventDate > currentDate
            }

            // Array of options to disable for future events
            const disabledOptions = isFutureEvent(event) ? [COMPLETED, ON_GOING] : []
            
            // console.log("disabled", disabled)

            return (
              <div item xs={12} sm={6} key={event.id}
                onClick={() => { onSelectEventCard({ ...event, isEditing: true }) }}
                style={{ cursor: "pointer" }}
              >
                <Card
                  sx={{
                    flexWrap: "wrap",
                    borderWidth: event?.doctorColor ? "0px 0px 0px 5px" : "0px",
                    borderStyle: "solid",
                    flexGrow: 1,
                    borderColor: event?.doctorColor ?? "none",
                    // boxShadow: "0 0 5px 5px #0000001a, 0 0 1px 0 #0000001a",
                    boxShadow: "0 4px 8px -2px #091e4240, 0 0 0 1px #091e4214",
                  }}
                >
                  <Box sx={{ p: "10px" }}>
                    {/* <Typography sx={{ textWrap: "wrap" }}>
                                        {event.title}
                                    </Typography> */}
                    <div className="space-between">
                      <Typography variant="body2" color="textSecondary">
                        <strong>
                          {isCancelled ? (
                            <del style={{ color: "red" }}>{event.clinicName}</del>
                          ) : (
                            event.clinicName
                          )}
                        </strong>
                      </Typography>

                      <CustomMenu
                        // selectedOption={selectedOption}
                        Icon={
                          <div
                            className="circle-container"
                            style={{ backgroundColor }}
                          ></div>
                        }
                        options={sideBarStatusOptions.slice(1)}
                        onChange={(status) => onChangeOption(event, status)}
                        buttonStyles={{ padding: "0px" }}
                        disabled={isCompleted}
                        disabledOptions={disabledOptions}
                      />
                    </div>

                    <Typography variant="body2" color="textSecondary">
                      <strong>Consultant:</strong> {doctorName}
                    </Typography>

                    {isMeeting && (
                      <Typography variant="body2" color="textSecondary">
                        <strong>Meeting With:</strong> {event.meetingWith}
                      </Typography>
                    )}

                    {!(isBreak || isMeeting) && <Typography variant="body2" color="textSecondary">
                      <strong>Patient Name:</strong> {event.patientName}
                    </Typography>}

                    <Typography variant="body2" color="textSecondary">
                      <strong>Appointment Type:</strong> {event.appointmentType}
                    </Typography>

                    <Typography variant="body2" color="textSecondary">
                      <strong>Time: </strong>
                      {getTime(event.start)} - {getTime(event.end)}
                    </Typography>

                    {creatorName && <Typography variant="body2" color="textSecondary">
                      <strong>Created By:</strong> {creatorName}
                    </Typography>}

                    <Typography variant="body2" color="textSecondary">
                      <strong>Status:</strong> {event.status}
                    </Typography>

                    {isSurgery && <Typography variant="body2" color="textSecondary">
                      <strong>Payment Status:</strong> {event.paymentStatus}
                    </Typography>}

                  </Box>
                </Card>
              </div>
            )
          })}
        </div>
      ) : (
        <p>No events for this date</p>
      )}
    </div>
  )
}

// Group by date and doctorId
const groupEvents = (events) => {
  const grouped = {}

  events.forEach((event) => {
    const dateKey = moment(event.start).format("YYYY-MM-DD")
    const doctorId = event.doctorId

    // Initialize the grouped object if not yet created
    if (!grouped[dateKey]) {
      grouped[dateKey] = {}
    }

    if (!grouped[dateKey][doctorId]) {
      grouped[dateKey][doctorId] = []
    }

    grouped[dateKey][doctorId].push(event)
  })

  return grouped
}

// Extract the first event for each doctor on a specific date
const getFirstEventPerDoctor = (groupedEvents) => {
  const selectedEvents = []

  Object.keys(groupedEvents).forEach((date) => {
    Object.keys(groupedEvents[date]).forEach((doctorId) => {
      const events = groupedEvents[date][doctorId]

      // Sort by start time (to ensure the first event is the earliest)
      const sortedEvents = events.sort(
        (a, b) => new Date(a.start) - new Date(b.start)
      )

      // Push the first event to the selectedEvents array
      selectedEvents.push(sortedEvents[0])
    })
  })

  return selectedEvents
}

export function getGroupedEvents(allEvents) {
  const groupedEvents = groupEvents(allEvents)
  const firstEvents = getFirstEventPerDoctor(groupedEvents)

  const formattedEvents = firstEvents.map((event) => ({
    ...event,
    title: event.title,
    start: new Date(event.start),
    end: new Date(event.end),
    id: event._id,
    doctorName: event.doctorName,
    doctorId: event.doctorId,
    patientName: event.patientName,
    doctorColor: event?.doctorColor ?? null,
  }))

  return formattedEvents
}

export const DayEvent = (event) => {
  const eventData = event?.event
  const label = eventData?.label + " - " + eventData?.appointmentType + " - " + eventData?.patientName
  
  return (
    <div title={label}>
      <span>
        {eventData?.status === CANCELLED ? <del style={{ color: "red" }}>{label}</del> : label}
      </span>
    </div>
  )
}